import Flex from 'quarks/Flex';
import Text from 'quarks/Text';
import type { BasicProps } from 'quarks/interpolations/basic';

import SubMenu from 'components/Header/SubMenu';

import type { ContentfulElementMenu } from 'graphqlTypes';
import type { FC } from 'react';

export interface SubMenuGroupProps extends BasicProps {
  group?: any;
  mobileMenu?: any;
  openMenuGroup?: any;
  businessType?: any;
  menu?: ContentfulElementMenu;
  handleMobileMenu?: () => void;
  setIsMobileNavOpen?: () => void;
  setOpenMenu?: () => void;
}

const SubMenuGroup: FC<SubMenuGroupProps> = ({
  handleMobileMenu,
  group,
  mobileMenu,
  openMenuGroup,
  businessType,
  setIsMobileNavOpen,
  setOpenMenu,
}) => {
  const { group: groupTitle, items } = group;

  const isTabbedMenu = items.some(item => item.businessType);
  const isSingleCol = !isTabbedMenu && items.length < 5;

  const listLength = () =>
    isSingleCol ? items.length : items.length % 2 === 0 ? items.length / 2 : Math.floor(items.length / 2) + 1;

  return (
    <Flex
      gap={groupTitle ? '15px' : '0'}
      paddingAll={0}
      flexDirection="column"
      key={groupTitle}
      className={`sub-menu-group ${groupTitle?.toLowerCase().replace(' ', '-')} ${
        !businessType
          ? ''
          : (openMenuGroup === 0 && businessType === 'Operations Suite') ||
            (openMenuGroup === 1 && businessType === 'Marketing Pro') ||
            (openMenuGroup === 2 && businessType === 'Fleet Pro')
          ? 'active'
          : 'inactive'
      }`}
      css={`
        @media (max-width: 575px) {
          .menu-items-lists {
            flex-direction: column;
          }
        }
      `}
    >
      <Text
        as="h4"
        textStyle="textXs"
        fontWeight="bold"
        textColor="green-300"
        display="block"
        cursor="pointer"
        width="100%"
        paddingY={16}
        textTransform="none"
        textAlign="left"
        transition="color 400ms ease-in-out"
        md={{ width: 'fit-content' }}
        lg={{ paddingAll: 0 }}
        css={`
          span {
            background: #66c4ab;
            padding: 3px 6px;
            border-radius: 5px;
            color: white;
            margin-left: 3px;
          }
        `}
      >
        {groupTitle}
      </Text>
      <Flex flexDirection="row" gap="30px" className="menu-items-lists">
        <Flex
          as="ul"
          paddingAll={0}
          width="max-content"
          flexDirection="column"
          css={`
            margin-left: -10px;

            @media (min-width: 992px) {
              display: grid;
              grid-template-rows: repeat(${listLength()}, 1fr);
              grid-auto-flow: column;
              column-gap: 20px;
              margin-left: -12px;
            }
          `}
        >
          {items?.map(
            menuItem =>
              menuItem && (
                <SubMenu
                  key={`submenu item ${menuItem?.heading}`}
                  menu={menuItem}
                  md={{ display: 'unset' }}
                  handleMobileMenu={mobileMenu ? handleMobileMenu : undefined}
                  setIsMobileNavOpen={setIsMobileNavOpen}
                  setOpenMenu={setOpenMenu}
                />
              ),
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default SubMenuGroup;
